import styled from "@emotion/styled";
import { AddIcon } from "@snapchat/snap-design-system-icons";
import { Input, Colors, Fonts, Button } from "@snapchat/snap-design-system";
import { Flexbox } from "../../core/components";

export const SectionTitle = styled.div`
    ${Fonts.Heading.H500}
`;

export const VendorDataContainer = styled.div`
    margin-left: 40px;
`;

export const PairContainer = styled(Flexbox)`
    margin-top: 16px;
`;

export const RemoveIconButton = styled(Button)`
    cursor: pointer;
    margin-top: 24px;
    font-size: 12px;
    color: ${Colors.Black.V50};
`;

export const DataInput = styled(Input)`
    flex: 1;

    :not(:last-child) {
        margin-right: 16px;
    }
`;

export const AddNew = styled(Flexbox)<{ hidden: boolean; disabled: boolean }>`
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    user-select: none;

    margin-top: 16px;

    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    color: ${({ disabled }) => (disabled ? Colors.Gray.V300 : Colors.Blue.V150)};

    visibility: ${({ hidden }) => (hidden ? "hidden" : "visible")};
`;

export const AddNewIcon = styled(AddIcon)`
    margin-right: 8px;
`;
